var _defs, _g, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBncr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "81.531mm",
    height: "35.894mm",
    viewBox: "0 0 81.531 35.894",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -278.5,
    y: 52.4,
    width: 793.7,
    height: 1122.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64.159 -130.55)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 63.139 427)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0",
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(304.79 562.77)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m-179.2 192.8c6.4 0 10.1 2.5 10.1 7v0.2c0 4.1-3.3 6.8-10.3 6.8h-16.1v-14zm-3.1 28.7c6.4 0 10 2.2 10 6.6v0.2c0 4.1-3.3 6.5-9.6 6.5h-13.7v-13.4h13.3zm-33.8 30.4h39c9.6 0 16.3-2.4 20.8-6.8 3-3 4.9-7.1 4.9-12.3v-0.2c0-8.8-5-14-11.7-17 9.2-3 15.1-8.3 15.1-18.6v-0.2c0-13-10.6-21-28.8-21h-39.2v76.1z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341.3 621.89)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m-179.2 192.8h19.7l31.3-40.2v40.2h20.9v-76.1h-18.5l-32.5 41.7v-41.7h-20.9z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(182.19 545.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m-179.3 192.8 32.8 91.5 35 10.2-16.5-101.7h-20.2l21.2 87-13.9-4-26.2-83z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(251.83 623.77)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m-179.2 192.8-8.9-77.9h15.6l0.9 65.5z"
  })))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBncr);
export default __webpack_public_path__ + "static/media/logo_bncr.d4ee391e9c8ce73253b99cd67bfadb91.svg";
export { ForwardRef as ReactComponent };